import React, {
    Component,
    PropTypes
} from 'react';
import render from "react-dom";
import {
    Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import  {bumpUrl}from '../../../path.config'
import bumpService from 'SERVICES/purifier/bump/bumpService'
import Tip from 'CONFIG/component/tip'
import ModalDel from 'CONFIG/component/ModalDel'
import {language,resultTip,pageOption} from 'UTIL/common'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
export default class PparamIndex extends Component {
	constructor(props) {
		super(props);
		this.onPageChange = this.onPageChange.bind(this);
		this.handle = this.handle.bind(this);
		this.delList = this.delList;
		this.del = this.del.bind(this);
		this.search = this.search.bind(this);
		this.state = {
			list: [],
			size: 10,
			current: 1,
			total: 0,
			delRow: {},
			url: bumpUrl,
		}

	};
	componentDidMount() {
		this.onPageChange(1,10)
	}
	handle(cell, row) {
		const edit_url = "/config/pparam/pparamEdit/"+row.id;
		return <div>
				<Link to={edit_url} className="btn btn-info btn-sm">{language()['edit']}</Link>&nbsp;&nbsp;
				<a  className="btn btn-danger btn-sm"  data-target="#delModal" data-toggle="modal"
					onClick={this.delList.bind(this,row.id,row.paramName)}>{language()['delete']} </a>
			</div>;
	};
	delList(id, name, e) {
		const delList = {
			"id": id,
			"name": name
		};
		this.setState({
			delRow: delList,
		})
	}
	search() {
        this.onPageChange(1,this.state.size)
	}
	del() {
		const _this = this;
		const id = this.state.delRow.id;
		bumpService.pparamDel(id).then(json=>{
            this.onPageChange(1,this.state.size);
            resultTip(json)
		})
	}
	onPageChange(page, sizePerPage, e) {
		console.log(page,sizePerPage)
        var  search= $.trim($("#search").val());
        const arr = {
            "page": page,
            "pageSize": sizePerPage,
            "search": search
        };
        var data =JSON.stringify(arr)
        bumpService.pparamList({data}).then(body=>{
        	console.log(body)
            const json = body.data;
            this.setState({
                list: json.records,
                total: json.total,
                current:page,
				size:sizePerPage,
            })
		})

	}
    targetMeta(cell,row){
		return row.targetMeta.name;
	}
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }
	render() {
        var create_url = "/config/pparam/pparamCreate";
        let options = pageOption(this.state.current,this.state.size);
        options['onPageChange'] = this.onPageChange.bind(this);
		return (
			<div >
				<section className="content-header " >
					<h1> {language()['BasicConfiguration']} <small>{language()['ProtocolParameter']}</small> </h1>
				</section>
				<section className="content" >
					<div className="box box-primary color-palette-box">
						<div className="box-header with-border">
							<i className="fa fa-list"></i>
							<h3 className="box-title">{language()['ProtocolParameterList']}</h3>
							<div style={{marginRight:"10px",float:"right"}}>
								<Link to ={create_url}  className="btn btn-success btn-md"  >
									<i className="fa fa-plus-circle"></i> {language()['add']}
								</Link>
							</div>
						</div>
						<div className="box-body">
							<Tip ids=""/>
							<div className="title-box">
								<div className="clearfix">
									<div className="f1">
										<label className="control-name fl">查询条件</label>
										<input type="text" className="form-control" autocomplete="off" style={{width:'260px'}}
											   id='search' placeholder={language()['paramCode']+'/'+language()['paramName']+'/'+language()['paramNameEn']}/>
									</div>
									<button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>&nbsp;&nbsp;
									<button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                        {language()['resetting']}
									</button>
								</div>
							</div>
							<div >
								<BootstrapTable data = {this.state.list}  striped hover pagination={true} options={options}
												remote={true} fetchInfo={{ dataTotalSize: this.state.total }}  >
									<TableHeaderColumn isKey dataField='id'hidden="true" >id </TableHeaderColumn>
									<TableHeaderColumn dataField='paramCode' width="120">{language()['paramCode']} </TableHeaderColumn>
									<TableHeaderColumn dataField='paramName'width="150">{language()['paramName']} </TableHeaderColumn>
									<TableHeaderColumn  dataField='paramNameEn'width="150">{language()['paramNameEn']} </TableHeaderColumn>
									<TableHeaderColumn  dataField='andvalue'width="120">{language()['andvalue']}  </TableHeaderColumn>
									<TableHeaderColumn  dataFormat={this.targetMeta.bind(this)}width="150">{language()['targetMeta']}</TableHeaderColumn>
									<TableHeaderColumn  dataFormat={this.handle}  width="150"columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
								</BootstrapTable>
							</div>
						</div>
					</div>
				</section>
				<ModalDel id="delModal" delModSure={this.del} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/bump/config/pparam/pparamIndex.js